
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
    state: {
        token: getToken(),
        userInfo: {},
        jobNo: null,
        scanTip: null, // 扫描记录
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            setToken(token)
            state.token = token
        }
    },
    actions: {
        
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js